export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyDxovzOlRs8qDxWdexHZG8qH9zRLfBdY6I",
    authDomain: "swiggycloneadmin.firebaseapp.com",
    databaseURL: "https://swiggycloneadmin.firebaseio.com",
    projectId: "swiggycloneadmin",
    storageBucket: "swiggycloneadmin.appspot.com",
    messagingSenderId: "635468684616",
    appId: "1:635468684616:web:b321e5ce25357c2b83e77d",
    measurementId: "G-F9ZP67TTJC"

  }
};
